<template>
  <div class="bg-neutral-300 shadow p-8">
    <Lynx-Title text="Desativamento" />
    <h2 class="pb-8 text-xl font-display text-primary-600">
      {{ this.getEmpresa.id }} | {{ this.getEmpresa.razao_social }}
    </h2>
    <div class="w-full flex justify-center" v-if="loading">
      <Lynx-Spinner size="12" />
    </div>
    <form class="flex flex-col" @submit.prevent="onSubmit" v-else>
      <div class="w-full flex">
        <Lynx-Textarea
          required
          placeholder="Descreva aqui o que motivou a sua nota"
          v-model="form.motivo"
          class="mt-2"
        />
      </div>

      <Lynx-Button
        :disabled="!hasRole('super-admin')"
        style="color: white"
        class="self-end mt-2"
        type="submit"
        text="Desativar"
        color="error-base"
        :loading="loadingButton"
      />
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { empresasExclusaoquest } from "@/services/requests/empresas";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import formMixin from "@/mixins/form";
import { monthNames, dayNames } from "@/utils/utils";
import LynxTextarea from "@/components/helpers/Textarea";
import { hasRole } from "@/utils/can";

export default {
  name: "EmpresaShowDesativamento",
  mixins: [formMixin],
  components: { LynxTextarea },
  data() {
    return {
      loading: false,
      loadingButton: false,
      monthNames,
      dayNames,
      motivosOptions: [],
      form: {
        motivo: "",
      },
      validationsMessage: {
        form: {
          data_competencia: {
            required: "Insira a data de competência do desativamento",
          },
          motivo_desativamento: {
            required: "Insira o motivo do desativamento",
          },
        },
      },
    };
  },
  validations: {
    form: {
      data_competencia: { required },
      motivo_desativamento: { required },
    },
  },
  computed: {
    ...mapGetters(["getEmpresa"]),
  },

  methods: {
    ...mapActions(["setEmpresa"]),
    moment,
    hasRole,

    async onSubmit() {
      this.$buefy.dialog.confirm({
        message: "Deseja realmente fazer a exclusao total?",
        confirmText: "Excluir",
        cancelText: "Cancelar",
        type: "is-danger",
        onConfirm: () => this.desativarEmpresa(),
      });
    },

    desativarEmpresa() {
      const form = {
        payer_id: this.getEmpresa.id,
        payer_type: "empresa",
        motivo: this.form.motivo,
      };

      this.loadingButton = true;
      empresasExclusaoquest(form)
        .then(() => {
          this.$router.push({ name: "empresas.index" });
          this.$snack.success("Empresa Excluida com sucesso");
        })
        .catch(() => this.$snack.error("Não foi possível excluir a empresa"))
        .finally(() => (this.loadingButton = false));
    },
  },
};
</script>
